<template>
    <div>
        <div v-if="$loadingRouteData"
             class="container -compnies">
            <loader></loader>
        </div>

        <div v-if="!$loadingRouteData"
             class="container -companies">
            <ol class="breadcrumb">
                <li><a v-link="{name: 'home'}">Accueil</a></li>
                <li>Companies</li>
            </ol>

            <div class="heading">
                <h1 class="expand">Companies</h1>
                    <a v-link="{name: 'companies-detail', params: {id: 'new'}}"
                       class="btn btn-default">
                        <i class="glyphicon glyphicon-plus"></i>
                        Ajouter une compagnie
                    </a>
            </div>

            <div class="search-area">
                <div class="search-row f -a-center">
                    <div class="form-group expand">
                        <label for="companies-search"
                               class="sr-only">
                            Chercher un membre
                        </label>
                        <div class="input-group">
                            <div class="input-group-addon">
                                <loader v-show="loading"></loader>
                                <i v-show="!loading" class="glyphicon glyphicon-search"></i>
                            </div>
                            <input type="text"
                                   class="form-control"
                                   id="companies-search"
                                   v-model="searchQuery"
                                   placeholder="Chercher un nom, un numéro de téléphone, etc">
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <table class="table table-hover -companies -row-links">
                    <tr>
                        <th>Nom de la companie</th>
                        <th>Code de la companie</th>
                    </tr>

                    <tr v-for="company in companies" class="row-company">
                        <td class="table-col">
                            <a href="#" v-link="{name: 'companies-detail',
                            params: {id: company.id}}">{{company.name}}</a>
                        </td>
                        <td class="table-col">
                            {{company.code}}
                        </td>
                    </tr>
                </table>
                <loader v-show="loading" class="bigger-loader"></loader>

                <div class="load-more text-center">
                    <a href="#"
                       v-if="hasNext && !loading"
                       v-on:click.prevent="updateList(true)"
                       class="btn btn-default">
                        Charger plus
                    </a>
                </div>
            </div>

        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import Loader from '../components/Loader';
    import CompanyBlock from '../components/companies/CompanyBlock';
    import {makeUpdateList} from '../utils';
    import {list} from '../api/companies';

    export default {
        components: {
            CompanyBlock,
            Loader
        },
        data() {
            return {
                hasNext: false,
                searchQuery: '',
                loading: false,
                companies: []
            };
        },
        watch: {
            searchQuery() {
                this.updateList();
            }
        },
        route: {
            data: async function () {
                this.updateList();
            }
        },
        methods: {
            updateList: makeUpdateList({
                loading: 'loading',
                page: 'page',
                hasNext: 'hasNext',
                list: 'companies',
                fetch: async function (page) {
                    return await list(
                        this.searchQuery,
                        page
                    );
                }
            })
        }
    };
</script>

<style scoped
       type="text/less"
       lang="less">
    @import '~src/style/variables';
    .heading {
        margin-bottom: @grid-gutter-width;

        h1 {
            display: inline;
            margin: 0;
        }
        .btn {
            float: right;
        }
    }
    .search-area {
        margin-bottom: @grid-gutter-width;
    }
</style>



// WEBPACK FOOTER //
// Companies.vue?5d597edb